import {
  isGKECluster,
  useCluster,
} from '@cast/shared-cluster-context-data-access';

export const useIsSoleTenantOfferingVisible = (): boolean => {
  const { cluster } = useCluster();
  return isGKECluster(cluster);
};
